import React, { Fragment } from 'react';

import { MenuItem, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowDropDown as ArrowDownIcon } from '@mui/icons-material';

import { useAuth, AuthCompanyContext, AuthRoutes } from '@homesusa/auth';
import { AppType } from '../../enums';
import { AppContext } from '../../contexts';
import { MenuStyled } from './header-user.style';
import { AnchorEl } from './use-anchor-el';

const buttonId = 'user-menu-appbar';

export function ProfileButton({ anchor }: { anchor: AnchorEl }): JSX.Element {
  const { userCompanies } = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();

  if (!userCompanies) {
    return <Fragment></Fragment>;
  }

  return (
    <Button aria-controls={buttonId} endIcon={<ArrowDownIcon />} onClick={anchor.handleClick}>
      {userProfile?.name}
    </Button>
  );
}

export function ProfileButtonMenu({ anchor }: { anchor: AnchorEl }): JSX.Element {
  const {
    appState: { apps, currentApp }
  } = React.useContext(AppContext);
  return (
    <MenuStyled
      anchorEl={anchor.anchorEl}
      open={anchor.open}
      onClose={anchor.handleClose}
      keepMounted
      id={buttonId}
    >
      <MenuItem
        {...(currentApp === AppType.UserManagement
          ? { to: '/profile', component: RouterLink }
          : { href: `${apps.userManagement}/profile`, component: 'a' })}
      >
        My Profile
      </MenuItem>
      <MenuItem to={AuthRoutes.Logout} component={RouterLink}>
        Logout
      </MenuItem>
    </MenuStyled>
  );
}
